import { render, staticRenderFns } from "./noteItem.vue?vue&type=template&id=fc95e896&scoped=true&"
import script from "./noteItem.vue?vue&type=script&lang=js&"
export * from "./noteItem.vue?vue&type=script&lang=js&"
import style0 from "./noteItem.vue?vue&type=style&index=0&id=fc95e896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc95e896",
  null
  
)

export default component.exports